import en from '@onuw/roles-data/strings/en.json'
import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

export const NAMESPACES = ['ui', 'roles', 'tokens', 'prompts', 'log', 'bots'] as const

i18next.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  ns: [...NAMESPACES],
  defaultNS: 'ui',
  resources: { en },
  // resources are bundled: initialise synchronously so prerendering and first paint have strings
  initAsync: false,
  interpolation: { escapeValue: false, skipOnVariables: false },
  returnNull: false,
})

export { i18next }
